import type { SVGProps } from "react";
import { memo } from "react";
const TensorFlowonAWS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M55 49.662V32.847l-14 7.927V57.59zm-30 0 14 7.928V40.774l-14-7.927zm1.04-18.536L40 39.03l13.96-7.904L40 23.22zm30.45 20.003-16 9.06a1 1 0 0 1-.98 0l-16-9.06a1.01 1.01 0 0 1-.51-.878V31.126c0-.364.195-.699.51-.878l16-9.06a1 1 0 0 1 .98 0l16 9.06c.315.18.51.514.51.878V50.25c0 .364-.195.699-.51.878m11.007-16.174-1.961.394c.29 1.463.464 3.4.464 5.181 0 12.11-8.496 22.837-20.202 25.507L46.239 68C58.849 65.124 68 53.572 68 40.53c0-1.934-.184-3.967-.503-5.575M14 40.53c0-1.767.174-3.509.516-5.175l-1.959-.406A27.8 27.8 0 0 0 12 40.53C12 53.572 21.151 65.124 33.761 68l.441-1.963C22.496 63.367 14 52.64 14 40.53m5.687-16.324-1.562-1.256C23.646 15.991 31.619 12 40 12c8.656 0 17.061 4.383 22.481 11.724l-1.605 1.202C55.831 18.093 48.027 14.013 40 14.013c-7.77 0-15.173 3.716-20.313 10.193"
      />
    </g>
  </svg>
);
const Memo = memo(TensorFlowonAWS);
export default Memo;
